import { render, staticRenderFns } from "./LockBadge.vue?vue&type=template&id=9f468db0&scoped=true"
import script from "./LockBadge.vue?vue&type=script&lang=js"
export * from "./LockBadge.vue?vue&type=script&lang=js"
import style0 from "./LockBadge.vue?vue&type=style&index=0&id=9f468db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f468db0",
  null
  
)

export default component.exports